import { Container } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

const cardStyles = css`
  height: fit-content;
  background: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => `${theme.radius.small}`};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;

export const StyledOuter = styled.div`
  margin: 3rem 0 6rem 0;
  padding: 0 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.4rem;

  h3 {
    font-size: 2.4rem !important;
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    margin-bottom: 1.6rem;
  }
  p,
  li,
  div,
  span {
    color: ${({ theme }) => theme.colors.text.lighter};
    font-size: ${({ theme }) => `${theme.fonts.sizes.default} !important`};
    line-height: 2rem;
  }
  p {
    text-align: left !important;
    margin-bottom: 1rem;
  }

  p:not(.title-row) {
    margin-bottom: 0;
  }

  ul,
  ol {
    margin: 1.4rem 0 1.4rem 1.2rem;
  }
  ul {
    list-style: disc;
    list-style-position: inside;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr 2fr;
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const StyledColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const StyledCardWithImage = styled.div`
  ${cardStyles};

  > div {
    padding: 2.4rem 2.4rem 3.2rem 2.4rem;
    border-radius: ${({ theme }) => `0 0 ${theme.radius.small} ${theme.radius.small}`};
  }

  p {
    margin-bottom: 0;
  }
`;

export const StyledCardContent = styled.div`
  ${cardStyles};
  padding: 3.2rem;

  display: flex;
  flex-direction: column;
  gap: 4.8rem;
`;

export const StyledDescription = styled.div`
  ul {
    margin: 1.4rem 0 0 1.2rem;
  }
`;

export const StyledCardImage = styled.img`
  width: 100%;
  height: 18.4rem;
  object-fit: cover;
  border-radius: ${({ theme }) => `${theme.radius.small} ${theme.radius.small} 0 0`};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    height: 25.4rem;
  }
`;

export const StyledCertImage = styled.img`
  width: 100%;
  border-radius: ${({ theme }) => `${theme.radius.small} ${theme.radius.small} 0 0`};
`;

export const StyledCardTitle = styled.p`
  font-size: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledSectionNumber = styled.p`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.lightest};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const StyledSectionTitleRow = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const StyledSectionTitle = styled.p`
  text-transform: capitalize;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: 2rem;
  margin: 0.8rem 1.2rem 0.8rem 0;
`;

export const StyledSal1Card = styled.div`
  ${cardStyles};

  div {
    padding: 2.4rem 3.2rem;
    border-radius: ${({ theme }) => `0 0 ${theme.radius.small} ${theme.radius.small}`};
  }

  h5 {
    margin-bottom: 0.8rem;
  }

  button {
    margin-top: 1.6rem;
  }
`;

export const StyledCertCard = styled.div`
  ${cardStyles};

  padding: 3.2rem;

  display: flex;
  flex-direction: column;

  h5 {
    margin-bottom: 2.4rem;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 1.6rem;
  }

  p {
    margin-bottom: 0;
  }
`;

export const StyledCertCardImage = styled.img`
  width: 8rem;
  height: auto;
`;
